import React from 'react';
import { Box } from 'roo-ui/components';
import PageBlock from 'components/PageBlock';
import FilterHeader from './FilterHeader';
import FilterMenu from './FilterMenu';

const RoomTypeFilters = () => {
  return (
    <PageBlock py={6} display={['none', 'block']}>
      <FilterHeader />
      <FilterMenu />
      <Box borderBottom={1} borderColor="greys.alto" pb={4} />
    </PageBlock>
  );
};

export default RoomTypeFilters;
